const main = 'doc-index'

const relativeRoutes = {
  relativePage: `${main}/*`,
  relativeList: `${main}`,
}

export const DocIndexRoutes = {
  ...relativeRoutes,
  List: `/${main}`,
}
